export { ComparerProduct } from './comparerProduct';
